module.exports = __webpack_public_path__ + "img/upload.2f9ee5a1.png";